import React from 'react'
import { Clock } from 'lucide-react'

interface ComingSoonBadgeProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  variant?: 'default' | 'subtle'
}

const ComingSoonBadge: React.FC<ComingSoonBadgeProps> = ({ 
  className = '', 
  size = 'sm',
  variant = 'default'
}) => {
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  }

  const variantClasses = {
    default: 'bg-ochre-100 dark:bg-ochre-500/30 text-ochre-500 border border-ochre-100 dark:bg-ochre-500/30 dark:text-ochre-500 dark:border-ochre-500',
    subtle: 'bg-cream-100 text-ink-500 border border-cream-400 dark:bg-ink-700 dark:text-ink-300 dark:border-ink-500'
  }

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-3.5 h-3.5',
    lg: 'w-4 h-4'
  }

  return (
    <span className={`
      inline-flex items-center space-x-1 rounded-full font-medium
      ${sizeClasses[size]}
      ${variantClasses[variant]}
      ${className}
    `}>
      <Clock className={iconSizes[size]} />
      <span>Em breve</span>
    </span>
  )
}

export default ComingSoonBadge
